import problems from "../../problemStore";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import WithSideBarAds from "../../Layout/WithSideBarAndHeaderAds";
import Footer from "../../Components/Footer";
import { Row, Col, Form, Table, Badge } from "react-bootstrap";
import { useState } from "react";
import Tags from "../../Components/Tags";
import { useSelector } from "react-redux";
import SEO from "../../Seo";

const ProblemsList = () => {
  const [selectedValue, setSelected] = useState("all");
  const submissionsList = useSelector(({ submissions }) => submissions);
  const { path } = useRouteMatch();

  let problemsList = problems;

  //filter the selected problems
  if (selectedValue !== "all") {
    problemsList = problemsList.filter(
      ({ difficulty }) => difficulty === selectedValue
    );
  }

  //generate list of problems
  const list = problemsList.map(({ url, title, difficulty }, index) => (
    <tr key={title}>
      <td>{index + 1}</td>
      <td>
        <Link to={`${path}/${url}`}>{title}</Link>
      </td>
      <td>
        <Tags text={difficulty} type={difficulty} />
      </td>
      <td>{submissionsList[url] && <Badge bg="success">Done 🏆</Badge>}</td>
    </tr>
  ));

  //onchange handler
  const onChangeHandler = ({ target }) => {
    setSelected(target.value);
  };

  return (
    <>
      <WithSideBarAds>
        <SEO
          text={`Problems List | Online JavaScript Practice Ground | Learnersbucket`}
          description={`Ace your JavaScript interviews by practicing System Design, Frontend Interview questions on learnersbucket.com, it requires no signup and works offline as well.`}
        />
        <main>
          <Row className="justify-content-end align-items-center">
            <Col xs={12} sm={6} lg={3} className="text-end">
              <label>
                <b>Filter:</b>
              </label>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Select
                size="sm"
                onChange={onChangeHandler}
                value={selectedValue}
              >
                <option value="all">All</option>
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </Form.Select>
            </Col>
          </Row>
          <br />
          <Table bordered responsive size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Problems</th>
                <th>Difficulty</th>
                <th>Practiced</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </Table>
        </main>
      </WithSideBarAds>
      <Footer />
    </>
  );
};

export default ProblemsList;
